import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { Customer, CustomerEmployee } from '../../customers/customers.model';
import { Employee } from '../employee.model';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { EmployeesRest } from '../employee.rest';
import { NgForm } from '@angular/forms';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { INgxSelectOption } from 'ngx-select-ex';
import { CustomersRest } from '../../customers/customers.rest';

@Component({
  selector: 'app-customer-selection',
  templateUrl: './customer-selection.component.html'
})
export class CustomerSelectionComponent implements OnInit {
  public employee: Employee;
  public currentEmployeer: String;
  public customers: ObjectToSelect[];
  //public customer: ObjectToSelect;
  public customerId: number;
  private employeesOpen = false;
  private isSaving = false;

  constructor(private rest: EmployeesRest, private customerRest: CustomersRest) { }

  @ViewChild('customerSelectionForm') customerSelectionForm: NgForm;
  @ViewChild(ModalComponent) public modal: ModalComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.customerSelectionForm.valid) {
      this.confirm();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.modal.title = 'Wybierz kontrahenta';
    //this.customer = new ObjectToSelect();
  }

  public selectCustomer(customers: ObjectToSelect[], employee: Employee) {
    this.employee = employee;
    this.customers = customers.filter(x => this.employee.customers.every(y => y.customerId !== x.id));
    this.modal.openWithCustomSize({ height: '25vh', width: '450px' });
  }

  public closeModal() {
    this.modal.close();
  }

  private confirm() {
    if (this.isSaving) {
      return;
    }

    this.addCustomerEmployee();
  }

  private addCustomerEmployee() {
    if (this.employee.id !== 0) {
      this.isSaving = true;
      const action = this.rest.addCustomerEmployee;
      action.call(this.rest, this.customerId, this.employee.id).subscribe((result: CustomerEmployee) => {
        let emmitData = { isSuccess: true, customer: result };
        this.onSuccess.emit(emmitData);
        this.isSaving = false;
      });
    } else {
      this.isSaving = true;
      this.customerRest.getCustomerDetails(this.customerId).subscribe((result: Customer) => {
        if (result) {
          let customerEmployee = new CustomerEmployee();
          customerEmployee.employeeId = this.employee.id;
          customerEmployee.customerId = result.id;
          customerEmployee.customerName = result.name;
          customerEmployee.customerCode = result.code;
          customerEmployee.customerEmail = result.email;
          customerEmployee.customerPhone = result.phone;
          customerEmployee.customerTin = result.nip;
          customerEmployee.id = (this.employee.customers.length !== 0 ? Math.min.apply(Math, this.employee.customers.map(function (o) { return o.id; })) : 0) - 1;
          let emmitData = { isSuccess: true, customer: customerEmployee };
          this.onSuccess.emit(emmitData);
          this.isSaving = false;
        }
      });
    }
    this.modal.close();
  }

  private onOpen() {
    this.employeesOpen = true;
  }

  private onClose() {
    this.employeesOpen = false;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }
}
